/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoTwitterIcon20Solid = forwardRef('LogoTwitterIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M15.684 4.62a1 1 0 1 0-1.513-1.308l-3.606 4.175L7.482 3.41c-.195-.258-.5-.41-.824-.41H4.32c-.854 0-1.34.977-.825 1.658l4.44 5.872-4.188 4.85a1 1 0 0 0 1.513 1.308l3.91-4.526 3.347 4.428c.195.258.5.41.825.41h2.336c.854 0 1.34-.977.825-1.658L11.798 9.12l3.886-4.5Z" })));
});
